<template>
  <div class="battery-icon" role="img" :aria-label="`电池电量 ${batterySocPercent}%`">
    <div class="battery-icon__terminal"></div>
    <div class="battery-icon__body">
      <div class="battery-icon__level" :style="{ height: `calc(${batterySocPercent}% - 4px)`, backgroundColor: batterySocColor }">
      </div>
    </div>
  </div>
</template>




<script setup>
import { ref, computed } from 'vue';

const props = defineProps({
  soc: {
    type: Number,
    default: 0
  }
})

const batterySocPercent = computed(() => {
  const soc = Number(props.soc)
  if (!Number.isFinite(soc)) return 0
  return Math.max(0, Math.min(100, Number(soc.toFixed(0))))
})

const batterySocColor = computed(() => {
  if (batterySocPercent.value <= 10) return '#FF6B6B'
  if (batterySocPercent.value <= 20) return '#F6B73C'
  return '#4CCB61'
})




</script>




<style scoped lang="scss">
.battery-icon {
  width: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.battery-icon__terminal {
  width: 10px;
  height: 3px;
  border-radius: 2px 2px 0 0;
  background: #4CCB61;
}

.battery-icon__body {
  position: relative;
  width: 24px;
  height: 36px;
  border: 2px solid #4CCB61;
  border-radius: 5px;
  padding: 2px;
  background: #ffffff;
  overflow: hidden;
}

.battery-icon__level {
  position: absolute;
  left: 2px;
  right: 2px;
  bottom: 2px;
  border-radius: 2px;
  transition: height 0.35s ease, background-color 0.35s ease;
}
</style>
